import React from "react"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { useAcrissGroups } from "Pages/OneWay/AcrissGroups/@hooks"


export default function AcrissGroupsButton() {
	const { handleSetFormData } = useAcrissGroups()

	return <ButtonLoadingSeeker
		startIcon={<IconSeeker icon="add" />}
		onClick={handleSetFormData}
	>
		Define Group
	</ButtonLoadingSeeker>
}
